export default {
  getSafe: function (fn, defaultVal) {
    try {
      return fn() || defaultVal
    } catch (e) {
      return defaultVal
    }
  },

  disabledEvent: function (e) {
    if (e.stopPropagation) {
      e.stopPropagation()
    } else if (window.event) {
      window.event.cancelBubble = true
    }
    e.preventDefault()
    return false
  },
  preventContextMenu: function () {
    document.addEventListener(
      'contextmenu',
      function (e) {
        e.preventDefault()
      },
      false
    )
  },
  disableKeyDown: function () {
    document.addEventListener(
      'keydown',
      function (e) {
        // "I" key
        if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
          this.disabledEvent(e)
        }
        // "J" key
        if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
          this.disabledEvent(e)
        }
        // "S" key + macOS
        if (e.keyCode === 83 && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
          this.disabledEvent(e)
        }
        // "U" key
        if (e.ctrlKey && e.keyCode === 85) {
          this.disabledEvent(e)
        }
        // "F12" key
        if (event.keyCode === 123) {
          this.disabledEvent(e)
        }
      },
      false
    )
  },
  blockRightClick: function () {
    this.preventContextMenu()
    this.disableKeyDown()
  },

  extractUuidFromTileSourceUrl: function (sourceUrl) {
    let parts = sourceUrl ? sourceUrl.split('/') : []
    return parts[parts.indexOf('file_files') - 1] || ''
  },

  getField: function (object, field) {
    return (object && object[field]) || false
  }
}
